/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PrimeFpieService = {
    async pushData(request: any, captchaToken: string): Promise<Response> {
        const payload = { ...request };

        // Gestion du fichier BankAttestation
        if (payload.bankAttestationFile) {
            payload.bankAttestationFileName =
                'BankAttestation' +
                getFileExtension(payload.bankAttestationFile);
            payload.bankAttestationFile = await fileToBase64(
                payload.bankAttestationFile
            );
        }

        // Formatage des champs
        payload.nationalRegisterTrainee =
            payload.nationalRegisterTrainee.replace(/[.-]/g, '');
        payload.numberCompany = payload.numberCompany.replace(/\./g, '');
        payload.addressCompany = formatAddress(
            payload.addressStreet,
            payload.addressNumber,
            payload.addressPostal,
            payload.addressLocality
        );

        payload.captchaToken = captchaToken;

        // Envoi vers l'API
        return fetch('/api/FondsRebond/PushFpie', {
            method: 'POST',
            headers,
            body: JSON.stringify(payload),
        });
    },
};

// --- Helpers ---

function getFileExtension(file: File): string {
    const parts = file.name.split('.');
    return parts.length > 1 ? '.' + parts.pop() : '';
}

function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
    });
}

function formatAddress(
    street: string,
    number: string,
    postal: string,
    locality: string
): string {
    return `${street} ${number}, ${postal} ${locality}`;
}
